<template>
  <b-button variant="link" @click="deleteEntry">Delete</b-button>
</template>

<script>
export default {
  props: ['eid', 'uid'],
  methods: {
    deleteEntry() {
      //alert('Delete:' + this.eid)
      let deleteOb = {
        eid: this.eid
      }
      if (this.uid) {
        // console.log('UID defined: ' + this.uid)
        deleteOb.uid = this.uid
      }
      // alert(JSON.stringify(deleteOb))
      if (confirm('Are you sure you want to delete this entry?')) {
        this.$store.dispatch('entry/deleteEntry', deleteOb)
      }
    }
  }
}
</script>

<style scoped>
</style>
